import {
  SET_SKILLS,
} from './mutation-types';
import SkillsAPI from '~/services/api/SkillsAPI';

/**
 * Create Skill request
 * @param {function} commit - The vuex commit function
 * @param {object} payload
 * @returns {Promise<unknown>}
 */
// eslint-disable-next-line
export async function requestSkill({ commit }, { payload }) {
  try {
    const requestedSkill = await SkillsAPI.requestSkill(payload);
    return Promise.resolve(requestedSkill);
  } catch (error) {
    return Promise.reject(error);
  }
}

/**
 * Fetch the skills of the current user
 * @param {function} commit - The vuex commit function
 * @param {function} userId - The IC id
 */
export async function fetchICSkills({ commit }, userId) {
  const skills = await SkillsAPI.fetchICSkills(userId);
  try {
    if (skills) {
      const { data } = skills;
      commit(SET_SKILLS, data);
    }
    return Promise.resolve(skills);
  } catch (error) {
    return Promise.reject(error);
  }
}
